const ACTION_LABELS: Record<string, string> = {
  bulk_read: 'Bulk read',
  CREATE_BRAND: 'Brand created',
  UPDATE_BRAND: 'Brand updated',
  DELETE_BRAND: 'Brand deleted',
  CREATE_CIGAR_LINE: 'Cigar line created',
  UPDATE_CIGAR_LINE: 'Cigar line updated',
  DELETE_CIGAR_LINE: 'Cigar line deleted',
}

export function formatAuditLogSummary(
  action: string,
  resource: string,
  resourceId?: string | null
): string {
  const label = ACTION_LABELS[action] ?? action.replace(/_/g, ' ').toLowerCase()
  const resourceLabel = resource.replace(/_/g, ' ')
  if (resourceId) {
    return `${label} — ${resourceLabel} (${resourceId.slice(0, 8)}…)`
  }
  return `${label} — ${resourceLabel}`
}
